<ax-drop-down [ngClass]="{ 'ax-disabled': disabled, 'ax-readonly': readonly }" [disabled]="disabled"
    [readonly]="readonly" [text]="_text" label="{{ label }}" icon="fas fa-calendar-alt" #dropdown [fitParent]="false"
    maxHeight="unset" (onOpen)="handleOnOpen()">
    <ax-calendar-box (valueChange)="onDateChange()" [(value)]="value" [type]="type" *ngIf="_renderPicker">
    </ax-calendar-box>
</ax-drop-down>
<div class="validation-text" *ngIf="errorText">
    {{ errorText }}
</div>